import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    fromInputId: String,
    toInputId: String
  }

  connect() {
    this.element.addEventListener('change', this.handleMonthChange)
  }

  disconnect() {
    this.element.removeEventListener('change', this.handleMonthChange)
  }

  handleMonthChange = (event) => {
    const selectedValue = event.target.value
    if (!selectedValue) return

    const [year, month] = selectedValue.split('-').map(Number)

    const firstDay = new Date(year, month - 1, 1)
    const lastDay = new Date(year, month, 0)

    this.updateDatePicker(this.fromInputIdValue, firstDay)
    this.updateDatePicker(this.toInputIdValue, lastDay)
  }

  updateDatePicker(inputId, date) {
    const event = new CustomEvent('react-date-time:force-change', {
      bubbles: true,
      detail: {
        id: inputId,
        date: date
      }
    })
    window.dispatchEvent(event)
  }
}
